import React from 'react';
import { Button, Column, Margin, ModalTrigger, Row } from '@upgrade/react-components';
import { mdiArrowRight } from '@mdi/js';

import Fluid from '../../Fluid';
import { Section, StyledLineHeader } from '../../common/styles';
import { Heading, Text } from '../../common/TypographyPublicSite';
import { StyledImage, StyledInfoColumn, StyledLinksColumn, StyledPartnerLinksList } from './styles';
import PartnerFormModal from '../PartnerFormModal';

const PartnerInvitation = ({
  partnerInvitation: {
    title,
    description,
    ctaButtonText,
    ctaButtonAriaLabel,
    scriptSrc,
    image,
    partnerLinksTitle,
    partnerLinks
  }
}) => {
  return (
    <Section borderless data-color="backgroundPage" padding="md">
      <Fluid padding={{ xs: ['lg', 'none'], sm: ['2xl', 'none'] }}>
        <Row xsHorizontalAlign="center">
          <Column xs={12} lg={10}>
            <Row gutter="large" xsHorizontalAlign="start" xsVerticalAlign="middle" xsDistribution="between">
              <Column xs={8} sm={5}>
                <StyledInfoColumn>
                  <Heading as="h4" marginBottom="sm" size="sm">
                    {title}
                  </Heading>
                  <Text as="p" color="contentWeak" marginBottom="lg" size="md">
                    {description}
                  </Text>
                  <ModalTrigger Modal={PartnerFormModal} scriptSrc={scriptSrc}>
                    <Button
                      className="hidden visible-sm"
                      emphasis="secondary"
                      fullWidth
                      buttonProps={{ 'aria-label': ctaButtonAriaLabel }}
                    >
                      {ctaButtonText}
                    </Button>
                  </ModalTrigger>
                </StyledInfoColumn>
              </Column>
              <Column xs={4} sm={3}>
                <StyledImage src={image} alt="" />
              </Column>
              <Column xs={12} sm={3} smOffset={1} lg={2} lgOffset={2}>
                <StyledLinksColumn>
                  <StyledLineHeader as="h5">{partnerLinksTitle}</StyledLineHeader>
                  <StyledPartnerLinksList>
                    {partnerLinks.map(({ ariaLabel, label, url }) => (
                      <li key={url}>
                        <Button
                          emphasis="tertiary"
                          href={url}
                          icon={mdiArrowRight}
                          alignIcon="end"
                          buttonProps={{ 'aria-label': ariaLabel }}
                        >
                          {label}
                        </Button>
                      </li>
                    ))}
                  </StyledPartnerLinksList>
                </StyledLinksColumn>
              </Column>
            </Row>
            <Row className="hidden-sm">
              <Column xs={12}>
                <Margin top="xl">
                  <ModalTrigger Modal={PartnerFormModal} scriptSrc={scriptSrc}>
                    <Button emphasis="secondary" fullWidth>
                      {ctaButtonText}
                    </Button>
                  </ModalTrigger>
                </Margin>
              </Column>
            </Row>
          </Column>
        </Row>
      </Fluid>
    </Section>
  );
};

export default PartnerInvitation;
